import state from './notificationsState.js'
import actions from './notificationsActions.js'
import mutations from './notificationsMutations.js'
import getters from './notificationsGetters.js'

export default {
  state,
  actions,
  getters,
  mutations,
}
